import DataSolly from "./dataSolly";
import DataMaxance from "./dataMaxance";
import DataAxa from "./dataAxa";
import DataFma from "./dataFma";

/*
 * Returns 1 if the IBAN is valid 
 * Returns FALSE if the IBAN's length is not as should be (for CY the IBAN Should be 28 chars long starting with CY )
 * Returns any other number (checksum) when the IBAN is invalid (check digits do not match)
 */
function checksumIBAN(input) {
    var iban = String(input).toUpperCase().replace(/[^A-Z0-9]/g, ''), // keep only alphanumeric characters
            code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/), // match and capture (1) the country code, (2) the check digits, and (3) the rest
            digits;
    if (( !code )||( code[1] !== 'FR' )||( iban.length !== 27 )) {
        return false;
    }
    // rearrange country code and check digits, and convert chars to ints
    digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, function (letter) {
        return letter.charCodeAt(0) - 55;
    });
    // final check
    return mod97(digits);
}

function mod97(string) {
    var checksum = string.slice(0, 2), fragment;
    for (var offset = 2; offset < string.length; offset += 7) {
        fragment = String(checksum) + string.substring(offset, offset + 7);
        checksum = parseInt(fragment, 10) % 97;
    }
    return checksum;
}

export default class DataDevis {

    constructor(devis) {
        for ( const key in devis ) {
            this[key] = devis[key]
        }
    }

    /// The typed id to be sent to the backend in order to identify this devis by id and between moto and auto collections
    typedId() {
        return this.type+this._id.$oid
    }

    getSolly() {
        return new DataSolly(this)
    }

    getLabel( field ) {
        return DataDevis.params[field][2] || field
    }

    getValueToLabel( field ) {
        return DataDevis.params[field][0]
    }

    getDisplayer( field ) {
        return DataDevis.params[field][3] ||( (v)=>v )
    }

    getStorer( field ) {
        return DataDevis.params[field][4] ||( (v)=>v )
    }

    getValue( field, deflt='' ) {
        return field in this.params ? this.params[field] : deflt
    }

    getMaxance() {
        if ( !this.maxanceInstance ) {
            this.maxanceInstance = new DataMaxance(
                this.maxance,
                this
            )
        }
        return this.maxanceInstance
    }

    getAxa() {
        if ( !this.axaInstance ) {
            this.axaInstance = new DataAxa(
                this.axa,
                this
            )
        }
        return this.axaInstance
    }

    getFma() {
        if ( !this.fmaInstance ) {
            this.fmaInstance = new DataFma(
                this.fma,
                this
            )
        }
        return this.fmaInstance
    }

    setValue( field, value ) {
        this.params[field] = value
    }

    getType( field ) {
        return DataDevis.params[field][0]
    }

    getDisplayValue( field ) {
        return field in this.params ? this.getDisplayer(field)(this.params[field]) : ''
    }

    /**
     * @param {*} field 
     * @returns false if field is valid, or an error message if invalid
     */
    validateMessage(field) {

        const value = this.params[field]
        const params = this.params


        if (( field == 'pays_naissance' )||( field == 'commune_naissance')) {

            if ( value &&( field == 'commune_naissance' ) ) {
                if ( value.match(/[^a-zA-Z\u00C0-\u017F -]/) ) {
                    return 'La commune de naissance ne doit contenir que des caractères alphabétiques'
                }
            }

            if ( ! ( params['pays_naissance'] || params['commune_naissance'] ) ) {
                return 'Indiquez votre pays de naissance si vous êtes né à l\'étranger, ou votre commune de naissance si vous êtes né en France.'
            } else return false

        }

        if ( field == 'departement_naissance' ) {
            if ( !( params['pays_naissance'] || value ) ) return 'Obligatoire sauf si vous êtes né à l\'étranger (dans ce cas, remplisser le pays de naissance'
            else return false
        }

        if ( value &&(( field == 'coefficient_auto')||( field == 'coefficient_moto'))) {
            if (( value < 50 )||( value > 350 )) {
                return 'Le bonus/malus est un nombre compris entre 50 (bonus maximal) et 350 (malus maximal)'
            } 
        }
        if (( field == 'own_iban' )&&( value != 'O' )&&( params['iban'] )&&( params['iban'].trim() )) {
            return 'Si vous souhaitez réaliser les prélevements depuis un compte bancaire qui n\'est pas à votre nom, merci de nous contacter par téléphone.'
        }

        if ( field == 'iban' ) {
            if (( !value )||( checksumIBAN(value) !== 1 )) return 'Ce numéro d\'IBAN n\'est pas un numéro français valide';
        }

        const sizeLimited36 = ['adresse','adresse2','chez','nom','prenom','ville','telephone','email','commune_naissance']
        if ( value &&( sizeLimited36.includes(field) ) ) {
            if ( value.length > 36 ) {
                return 'Cette ligne doit faire moins de 36 caractères.'
            }
        }

        if ( value &&( field == 'telephone' ) ) {
            if ( value.length != 10 ) {
                return 'Merci d\'entrer un numéro de téléphone français à 10 chiffres. 06xxxxxxxx'
            }
        }


        if ( value &&( field == 'date_effet' )) {
            try {
                const now = new Date();
                const today = new Date(now.getFullYear(), now.getMonth(), now.getDate()); // Sets time to 00:00:00

                const effect = value.split("/");
                const effectDate = new Date( effect[2], effect[1] - 1, effect[0]);

                if (effectDate.getTime() < today.getTime()) {
                    return 'La date d\'effet doit être égale ou postérieure à la date du jour'
                }
                if (( effectDate.getTime() >= now.getTime() + 60 * 24 * 3600 * 1000)) { // 60 days in milliseconds
                    return 'La date d\'effet ne peut être plus de 60 jours dans le futur'
                }
            } catch (e) {
                console.log(e)
                return 'La date d\'effet est mal-formée'
            }
        }

        if (( field == 'accept_cgu' )&&( value != 'O' )) {
            return 'Vous devez accepter les CGU pour pouvoir souscrire.'
        }

        if ( value &&( field == 'numero_serie' )) {
            if ( value.length != 7 ) {
                return 'Le numéro de série doit être composé des 7 derniers caractères de la section E de votre carte grise.';
            }                
        }

        if ( value &&(( field == 'immatriculation' )||( field == 'previous_insurer_immat' ))) {
           if ( !value.match(/^([A-Z][A-Z])[-\s]*([0-9][0-9][0-9])[-\s]*([A-Z][A-Z])$/i ) ) {
            return 'L\'immatriculation doit être au format XX 000 XX, où X est une lettre, 0 un chiffre.';
           }
        }

        if (( field == 'ant_resiliation_non_paiement' )&&( params['ant_resiliation'] == 'O' )
            &&( params['ant_resiliation_non_paiement'] != 'O' )
            &&( params['ant_resiliation_fausse_declaration'] != 'O' )
            &&( params['ant_resiliation_frequence_sinistres'] != 'O' )
            &&( params['ant_resiliation_autre_motif'] != 'O' )) {

            return 'Veuillez choisir un motif de résiliation dans la liste'
        }

        if (( field == 'formule' )||( field == 'periodicite' )) {
            if ( !( params['formule'] && params['periodicite'] ) ) {
                return 'Veuillez choisir une formule et une fréquence de paiement'
            }
            return false
        }

        if ( field == 'modele' ) {
            if ( ! params['modele'] ) {
                return 'Veuillez choisir un modèle dans la liste'
            }
        }

        if ( field == 'aussi_permis_A2' ) {
            if ( params['categorie_permis'] != 'A' ) return false; // check only for permis A
        }

        if ( field == 'bonus_50_plus_3_ans' ) {
            if (( parseInt(params.coefficient_moto) > 50 )&&( parseInt(params.coefficient_auto) > 50 )) {
                return false; // check only if bonus >= 50
            }
        }

        const allowEmptyDate = ['previous_insurer_term']

        if ( typeof DataDevis.params[field][0] === 'object' ) {
            if ( !value ) return 'Veuillez choisir une réponse'
        } else {
            switch ( DataDevis.params[field][0] ) {
                case 'ouinon': 
                    if (( value != 'O' )&&( value != 'N' )) {
                        return 'Veuillez choisir une réponse'
                    }
                    break;
                case 'date':
                    if ( !value ) {
                        if ( !allowEmptyDate.includes(field) ) return 'Veuillez choisir une date'
                    } else {
                        if ( !value.match( /^[0-9]{1,2}\/[0-9]{1,2}\/[0-9]{4}$/ ) ) {
                            return 'La date est mal-formée'
                        }
                    }
                    break;
                case 'numeric':
                    if (( value === undefined )||( isNaN(value.toString()) )) return 'Veuillez entrer un nombre'
                    if ( !value.toString().length ) return 'Veuillez choisir une réponse'
                    break;
                case 'nonempty':
                    if ( !value ) return 'Veuillez remplir ce champ'
                    break
                case 'email':
                    if ( ! /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value) ) {
                        return 'L\'adresse email n\'est pas valide'
                    }
                    break
            }
        }

        return false
    }

    yes(field) {
        return this.params[field] == 'O'
    }

    collectSinistres(type,array,n) {
        const norm_name = 'sinistres_'+(((type=='vi')||(type=='bg'))?'nr':type)
        const name = 'sinistres_'+type
        if ( this.yes(norm_name) ) {
            for ( let i = 1 ; i <= n ; i++ ) {
                const field = name+'_date'+i
                const date = this.getValue(field)
                const vehicule = ( this.getValue( name+'_type'+i, 'MOTO' ) == 'AUTO' )?'AUTO':'MOTO'
                if ( date ) array.push( {type:type,date:date,vehicule:vehicule} ) 
            }
        }
    }

    /** 
     * @return an array of all sinistres. A sinistre is an object {type,date}.
     * Where type is in nr, vi, bg, mr, cr
     */
    getSinistres() {
        let sinistres = []
        this.collectSinistres('nr',sinistres,6)
        this.collectSinistres('vi',sinistres,6)
        if ( this.type == 'auto' ) this.collectSinistres('bg',sinistres,6)
        this.collectSinistres('mr',sinistres,5)
        this.collectSinistres('cr',sinistres,2)
        return sinistres
    }

    addSinistre( type, date, vehicule, changeParams ) {
        const n = DataDevis.typeToN[type]
        date = DataDevis.dateToParam(date)
        for ( let i = 1 ; i <= n ; i++ ) {
            if ( ! this.getValue('sinistres_'+type+'_date'+i) ) {
                const typeNorm = (( type=='vi' )||(type=='bg'))?'nr':type // vi & bg are counted under nr
                changeParams({ 
                    ['sinistres_'+typeNorm] : 'O', 
                    ['sinistres_'+type+'_date'+i] : date,
                    ['sinistres_'+type+'_type'+i] : ( vehicule==='AUTO' )?'AUTO':'MOTO' 
                })
                break
            }
        }
    }

    _checkAnySinistre( type ) {
        const n = DataDevis.typeToN[type]
        for ( let i = 1 ; i <= n ; i++ ) {
            if ( this.getValue('sinistres_'+type+'_date'+i) ) {
                return true;
            }
        }
        return false;
    }

    /**
     * @return true if there is a "sinistre" in type 'type'
     * Type vi and nr are treated as one type
     */
    checkAnySinistre( type ) {
        if (( type == 'nr' )||( type == 'vi' )||( type == 'bg' )) return this._checkAnySinistre('vi')||this._checkAnySinistre('nr')||this._checkAnySinistre('bg')
        return this._checkAnySinistre(type)
    }

    removeSinistre( type, date, vehicule, changeParams ) {
        const n = DataDevis.typeToN[type]
        let i = 1
        let newParams = {}
        for ( ; i <= n ; i++ ) {
            const d = this.getValue('sinistres_'+type+'_date'+i)
            const v = ( this.getValue('sinistres_'+type+'_type'+i) == 'AUTO' )?'AUTO':'MOTO'
            if (( d == date )&&( v == vehicule )) {
                break
            }
        } 
        // here, i is on the one we want to remove
        for ( ; i < n ; i++ ) {
            // slide everybody after
            const v = this.getValue('sinistres_'+type+'_date'+(i+1))
            this.setValue('sinistres_'+type+'_date'+i,v)
            newParams['sinistres_'+type+'_date'+i] = v

            const vt = this.getValue('sinistres_'+type+'_type'+(i+1))
            this.setValue('sinistres_'+type+'_type'+i,vt)
            newParams['sinistres_'+type+'_type'+i] = vt
        }
        // Drop last one
        this.setValue('sinistres_'+type+'_date'+n,'')
        newParams['sinistres_'+type+'_date'+n] = ''
        this.setValue('sinistres_'+type+'_type'+n,'')
        newParams['sinistres_'+type+'_type'+n] = ''

        newParams['sinistres_'+(((type=='vi')||( type == 'bg' ))?'nr':type)] = this.checkAnySinistre( type ) ? 'O' : 'N'

        changeParams(newParams)
    }

    defaultFormule() { return (this.type=='auto')?'L1':'M2'; }

    getWarranty(f) {
        const formule = f || this.getValue('formule',this.defaultFormule())
        const warranties = this.getValue('warranties')
        if ( !( formule && warranties ) ) return false
        return warranties.find( w => ( w.Z_FORM==formule ) )
    }

    getOptions() {
        const selectedOptions = this.getValue('selectedOptions',[])
        return this.getValue('options',[]).filter(
            opt => selectedOptions.includes( opt.Z_CODOPT )
        )
    }

    /** Float value of yearly fees : base fee (frais) + additional fee (frais_sup) */
    frais() {
        return Math.min( parseFloat(this.getValue('frais',0))+parseFloat(this.getValue('frais_sup',0)), ( this.type == 'moto' )?170.0:200.0 )
    }
 
    toPay(noOptions=false) {
        const periodicite = this.getValue('periodicite','A')
        let optionsPrice = 0
        if ( !noOptions ) {
            switch ( periodicite ) {
                case 'A':
                    optionsPrice = this.getOptions().reduce( (sum,opt) => sum + parseFloat(opt.Z_MTAOP), 0 )
                    break;
                case 'M':
                    optionsPrice = this.getOptions().reduce( (sum,opt) => sum + parseFloat(opt.Z_MTMOP*2), 0 )
                    break
            }
        }
    
        const warranty = this.getWarranty()
   //     const options = this.getOptions()
        if ( !( periodicite && warranty ) ) return false
        switch ( periodicite ) {
            case 'A':
                return this.fancyPrice( parseFloat(warranty.Z_MTAN) + optionsPrice )
            case 'M':
                return this.fancyPrice( 2*parseFloat(warranty.Z_MTMENS) + this.frais() + optionsPrice )
        }
        return false
    }

    fancyPrice( price, post='', deflt=' -' ) {
        return DataDevis.fancyPrice(price,post,deflt)
    }

    toPayMonthly(formule,noOptions=false) {
        if ( !formule ) formule = this.getValue('formule',this.defaultFormule())
        const warranty = this.getWarranty(formule)
        if ( !warranty ) return ''
        const optionsPrice = noOptions ? 0 : this.getOptions().reduce( (sum,opt) => sum + parseFloat(opt.Z_MTMOP), 0 )
        return this.fancyPrice( parseFloat(warranty.Z_MTMENS)+optionsPrice )
    }

    toPayMonthlyYearlyFormule() {
        const warranty = this.getWarranty(this.getValue('formule',this.defaultFormule()))
        if ( !warranty ) return ''
        const periodicite = this.getValue('periodicite','A')
        return this.fancyPrice( parseFloat(( periodicite == 'M' )? warranty.Z_MTMENS : warranty.Z_MTAN ) )
    }

    hasTarif() {
        const warranty = this.getWarranty(this.getValue('formule',this.defaultFormule()))
        const periodicite = this.getValue('periodicite','A')
        return warranty && +( ( periodicite == 'M' ) ? warranty.Z_MTMENS : warranty.Z_MTAN )
    }

    toPayMonthlyYearlyOptions() {
        const periodicite = this.getValue('periodicite','A')
        return this.fancyPrice( this.getOptions().reduce( (sum,opt) => sum + parseFloat(( periodicite == 'M' )?opt.Z_MTMOP:opt.Z_MTAOP), 0 ) )
    }

    toPayMonthlyYearly() {
        const warranty = this.getWarranty(this.getValue('formule',this.defaultFormule()))
        if ( !warranty ) return ''
        const periodicite = this.getValue('periodicite','A')
        return this.fancyPrice( parseFloat((( periodicite == 'M' )? warranty.Z_MTMENS : warranty.Z_MTAN ))+parseFloat(this.getOptions().reduce( (sum,opt) => sum + parseFloat(( periodicite == 'M' )?opt.Z_MTMOP:opt.Z_MTAOP), 0 ) ) )
    }

    fees() {
        return this.fancyPrice( this.frais() )
    }

    toPayYearlyNoFee() {
        const frais = this.frais()
        const periodicite = this.getValue('periodicite','A')
        let optionsPrice = 0
        switch ( periodicite ) {
            case 'A':
                optionsPrice = this.getOptions().reduce( (sum,opt) => sum + parseFloat(opt.Z_MTAOP), 0 )
                break;
            case 'M':
                optionsPrice = this.getOptions().reduce( (sum,opt) => sum + parseFloat(opt.Z_MTMOP*12), 0 )
                break
        }
    
        const warranty = this.getWarranty()
        if ( !( periodicite && warranty ) ) return false
        switch ( periodicite ) {
            case 'A':
                return this.fancyPrice( parseFloat(warranty.Z_MTAN) + optionsPrice - frais )
            case 'M':
                return this.fancyPrice( 12*parseFloat(warranty.Z_MTMENS) + optionsPrice )
        }
        return false
    }

    hasSollyTarifs() {
        return this.solly_ref &&( this.solly_validated >= 0 )&& this.solly_tarifs
    }

    sollyAnnuel() {
        if ( !this.solly_tarifs ) return ''
        const tarif = this.solly_tarifs[ this.getValue('formule','M2') ]
        if ( !tarif ) return ''

        return this.fancyPrice( tarif.annuel )
    }

    sollyCoutTotalMensuel() {
        if ( !this.solly_tarifs ) return ''
        const tarif = this.solly_tarifs[ this.getValue('formule','M2') ]
        if ( !(tarif&&tarif.acompte&&tarif.mensuel) ) return ''

        return this.fancyPrice( parseFloat(tarif.acompte) + 11*parseFloat(tarif.mensuel) )
    }

    sollyAcompte() {
        if ( !this.solly_tarifs ) return ''
        const tarif = this.solly_tarifs[ this.getValue('formule','M2') ]
        if ( !tarif ) return ''

        return this.fancyPrice( tarif.acompte )
    }

    sollyMensuel() {
        if ( !this.solly_tarifs ) return ''
        const tarif = this.solly_tarifs[ this.getValue('formule','M2') ]
        if ( !tarif ) return ''

        return this.fancyPrice( tarif.mensuel )
    }

    toPayYearly(noOptions=false,nofancy=false,formula=false) {
        const frais = this.frais()
        const periodicite = this.getValue('periodicite','A')
        let optionsPrice = 0
        if ( !noOptions ) {
            switch ( periodicite ) {
                case 'A':
                    optionsPrice = this.getOptions().reduce( (sum,opt) => sum + parseFloat(opt.Z_MTAOP), 0 )
                    break;
                case 'M':
                    optionsPrice = this.getOptions().reduce( (sum,opt) => sum + parseFloat(opt.Z_MTMOP*12), 0 )
                    break
            }
        }
    
        const warranty = this.getWarranty(formula)
        if ( !( periodicite && warranty ) ) return false
        const rt = ( periodicite == 'A' )? parseFloat(warranty.Z_MTAN) + optionsPrice : 12*parseFloat(warranty.Z_MTMENS) + optionsPrice + frais
        return nofancy ? rt : this.fancyPrice(rt)
    }

    getOptionText(code) {
        return DataDevis.optionCodeToText[code]
    }

    getFormuleText(code) {
        return DataDevis.formuleCodeToText[code] || ''
    }

    hamonApplies() {
        return (this.getValue('hamon_deja_assure')=='O')&&(this.getValue('hamon_assure_au_moins_12_mois')=='O')&&(this.getValue('hamon_resiliation_necessaire')=='O')&&(this.getValue('hamon_resiliation_envoyee')=='N')
    }

    need_A2() {
        if ( !( this.params.date_obtention_permis && this.params.categorie_permis ) ) return false
        const date = DataDevis.paramToDate(this.params.date_obtention_permis)
        const limit_date = DataDevis.paramToDate('19/01/2013')
        const category = this.params.categorie_permis
        return ( category =='A' )&&( date>=limit_date )
    }


    getOptionsFrais( isAdmin ) {
        let rt = []
        let ct = 0
        for ( let f = isAdmin ? 0 : this.base_frais ; ( f <= this.max_frais )&&( ct < 50 ) ; f += 10, ct++ ) {
            rt.push( {value:''+f+'.00',label:''+f+' €'})
        }
        return rt
    }

    getOptionsFraisSup( isAdmin ) {
        let rt = []
        const frais = parseFloat(this.getValue('frais','0.0'))
        for ( let f = isAdmin ? -50 : 0 ; ( f <= 70 )&&( frais+f <= this.max_frais ) ; f += 10 ) {
            rt.push( {value:''+f+'.00',label:''+f+' €'})
        }
        return rt
    }

    getStage() {
        if ( this.status_process != 'ongoing' ) return this.status_process
        return this.progress
    }

    getStageText() { 
        return DataDevis.stageToText[ this.getStage() ]
    }

}

DataDevis.stageToText = {
    'payment' : 'Page de paiement',
    'confirm' : 'Page de confirmation',
    'onsite' : 'Sur le site',
    'ongoing' : '',
    'paid_subscribed' : 'Souscrit',
    'subscribing' : 'Souscription en cours',
    'subscribe_error' : 'Erreur de souscription',
    'presubscribe_error' : 'Erreur de souscription',
    'cancelled' : 'Annulé'
}

DataDevis.optionCodeToText = {
    'AST':<>ASSISTANCE ASSUR BON PLAN avec la collaboration d'EUROP ASSISTANCE.<br/>
    Assistance sans franchise kilométrique, en France métropolitaine et dans la plupart des pays d'Europe (en cas de panne, d'accident,
    de tentative de vol, de vol, de crevaison, de perte/vol/casse/enfermement de clés ou d'enlèvement par la fourrière) pour votre véhicule,
    vous et votre famille, en voyage, ensemble ou séparément.<br/>
    Véhicule de remplacement pour une durée d'immobilisation supérieure à 48h. Forfait remorquage sur autoroute et voies express dans la limite de 300 Euros.</>,
    'IP1':<>ASSURANCE PILOTE vous garantit lors d'un accident au guidon de votre moto :<br/>
    Plafonds et limites de garanties (déduction faite des sommes allouées par les organismes sociaux et assimilés) :
    En cas de décès, un capital de : <br/>- 2000 EUR au titre des frais d'obsèques.
    <br/>- 8000 EUR reversés à votre conjoint ou concubin.
    <br/>- 3000 EUR par enfant à charge (dans la limite de 12000 EUR).
    <br/>En cas de déficit fonctionnel, un capital proportionnel à votre taux de déficit fonctionnel dans la limite de 300000 EUR, pour tout déficit fonctionnel
    permanent supérieur à 15%. Frais médicaux, pharmaceutiques et d'hospitalisation dans la limite de 1000 EUR.</>,
    'IP2':<>ASSURANCE PILOTE 'PLUS' vous garantit lors d'un accident au guidon de votre moto :
    Plafonds et limites de garanties (déduction faite des sommes allouées par les organismes sociaux et assimilés) :
    En cas de décès, un capital de : <br/>- 5000 EUR au titre des frais d'obsèques.
    <br/>- 15000 EUR reversés à votre conjoint ou concubin.
    <br/>- 5000 EUR par enfant à charge (dans la limite de 20000 EUR).
    <br/>En cas de déficit fonctionnel, un capital proportionnel à votre taux de déficit fonctionnel dans la limite de 800000 EUR, pour tout déficit fonctionnel
    permanent supérieur à 15%. Frais médicaux, pharmaceutiques et d'hospitalisation dans la limite de 1500 EUR.</>,
    'AC1':<>ASSURANCE ACCESSOIRES<br/>
    Extension des garanties Dommages Collision et Dommages Tous Accidents à concurrence de 1000 EUR.
    <br/>- aux accessoires hors-série ayant fait l'objet d'une facturation.
    <br/>- à l'équipement vestimentaire de protection du motard,
    et remboursement du casque à concurrence de 250 EUR en complément du remboursement au titre de la garantie Casque.
    Extension des garanties Vol et Incendie à concurrence de 1000 EUR aux accessoires hors-série ayant fait l'objet d'une facturation.
    Extension du remboursement au prix d'acquisition pour les véhicules acquis neufs depuis moins de 18 mois.</>,
    'AC2':<>ASSURANCE ACCESSOIRES 'PLUS'<br/>
    Extension des garanties Dommages Collision et Dommages Tous Accidents à concurrence de 10000 EUR.
    <br/>- aux accessoires hors-série ayant fait l'objet d'une facturation.
    <br/>- à l'équipement vestimentaire de protection du motard,
    et remboursement du casque à concurrence de 250 EUR en complément du remboursement au titre de la garantie Casque.
    Extension des garanties Vol et Incendie à concurrence de 10000 EUR aux accessoires hors-série ayant fait l'objet d'une facturation.
    Extension du remboursement au prix d'acquisition pour les véhicules acquis neufs depuis moins de 18 mois.</>
}

DataDevis.optionCodeToTitle = {
    'AST':'Assistance 0km + véhicule de remplacement',
    'IP1':'Assurance individuelle pilote jusqu\'à 300 000 €',
    'IP2':'Assurance individuelle pilote jusqu\'à 800 000 €',
    'AC1':'Assurance accessoires jusqu\'à 1 000 €',
    'AC2':'Assurance accessoires jusqu\'à 10 000 €'
}

DataDevis.formuleCodeToText = {
    'M2':<><h3>RESPONSABILITE CIVILE</h3>
    <p>
    La Compagnie vous garantit contre les conséquences pécuniaires de la Responsabilité Civile que vous pouvez encourir en raison des dommages
    matériels et corporels que vous pouvez causer à autrui, y compris à votre passager. Dommages corporels illimités - Dommages matériels limités à
    100000000 EUR en cas d'accident et 1300000 EUR en cas d'incendie.
    Une franchise supplémentaire de 1000 EUR sera appliquée si au moment du sinistre, vous ou un conducteur désigné n'êtes pas le pilote du véhicule.
    </p>
    <h3>DEFENSE PENALE ET RECOURS SUITE A ACCIDENT ET PROTECTION JURIDIQUE</h3>
    <p>
    La Compagnie s'engage à réclamer la réparation des préjudices corporels ou matériels subis par l'assuré et les personnes transportées suite à un accident.
    Protection juridique en cas de conflit lors de l'achat, la vente, l'entretien ou le financement du véhicule assuré, contre les conséquences d'une
    infraction aux règles de la circulation et pour la prise en charge à concurrence de 50% du prix du stage de reconstitution de point.
    </p>
    
    <h3>GARANTIE DU CASQUE, DES GANTS ET DU GILET AIRBAG</h3>
    <p>
    Remboursement (déduction faite de la vétusté) du casque à concurrence de 250 EUR et/ou des gants à concurrence de 70 EUR et/ou du gilet
    airbag à concurrence de 500 EUR, détérioré(s) suite d'un des événements ayant donné lieu à indemnisation et couverts au titre de la garantie
    Responsabilité Civile, sur présentation d'une facture d'achat nominative.
    </p></>,
    'M3':<><h3>VOL / INCENDIE</h3><p>Votre véhicule doit :<br/>
    1- être équipé d'un système électronique ou mécanique de protection antivol classe SRA,<br/>
    2- être gravé et inscrit à votre nom au fichier central des véhicules gravés (ARGOS) par une société de gravage des deux roues agréée SRA.<br/>
    Remboursement des dommages directs résultant de la disparition ou de la détérioration de votre véhicule causés exclusivement par un vol,
    un incendie ou une tentative de vol matérialisée par des traces d'effraction, à concurrence de sa valeur de remplacement, à dire
    d'expert, au jour du sinistre ou du prix d'acquisition pour les véhicules acquis neufs depuis moins de 6 mois (Sauf : location longue durée,
    location avec option d'achat et crédit-bail), déduction faite d'une franchise de 10 % (avec minimum 400 EUR et maximum 800 EUR).
    Si vous ne pouvez justifier de la mise en oeuvre de ces deux protections (antivol mécanique ou électronique ET gravage), la franchise sera doublée.
    </p></>,
    'M4':<><h3>DOMMAGES COLLISION</h3>
    <p>Remboursement des dommages subis par votre véhicule ayant pour cause exclusive une collision (choc) avec un tiers identifié à concurrence de sa
    valeur de remplacement, à dire d'expert, au jour du sinistre ou du prix d'acquisition pour les véhicules acquis neufs depuis moins de 6 mois (Sauf :
    LDD, LOA et crédit-bail), déduction faite d'une franchise de 10 % (avec minimum 400 EUR et maximum 800 EUR).
    Une franchise supplémentaire de 1000 EUR sera appliquée si au moment du sinistre, vous ou un conducteur désigné n'êtes pas le pilote du véhicule.</p></>,
    'M7':<><h3>DOMMAGES TOUS ACCIDENTS ('TOUS RISQUES')</h3>
    <p>Remboursement des dommages subis par votre véhicule suite à un accident (avec ou sans collision et que le véhicule ait été en mouvement ou à l'arrêt)
    à concurrence de sa valeur de remplacement, à dire d'expert, au jour du sinistre ou du prix d'acquisition pour les véhicules acquis neufs depuis moins
    de 6 mois (Sauf : LLD, LOA et crédit-bail), déduction faite d'une franchise de 10 % (avec minimum 400 EUR et maximum 800 EUR).
    Une franchise supplémentaire de 1000 EUR sera appliquée si au moment du sinistre vous ou un conducteur désigné n'êtes pas le pilote du véhicule.</p></>
}

// Each parameter -> ( key, title recap, title, displayer, storer )
DataDevis.params = {
    
    //'hamon_deja_assure' FMA
    // Retrait annulation alcool stup moins de 60 mois
    // csp
    // mode_garage
    // pays_naissance
    'fma_selected':['numeric',0,'Confirmez le modèle exact'],
    'contact_epistolaire':['ouinon','N','Mode de contact par courrier épistolaire (non éléctronique)'],
    'departement_naissance':['text','','Votre département de naissance'],
    'usage_auto':[
        {'10':'Privé',
            '20':'Privé + Trajet',
            '30':'Affaires (professionnel)',
            '40':'Tous déplacements'
        },
        '20',
        'Usage du véhicule'
    ],
    'premier_contrat':['ouinon','O','S’agit-il du premier contrat d’assurance depuis la mise en circulation du véhicule ?'],
    'nb_ans_bonus_50_moto':['numeric',0,'Nombre d\'années écoulées depuis acquisition du bonus 50'],
    'ant_retrait_motif_full':[{
       '':'N/A',
       'EXCES_VITESSE':'Excès de vitesse', 
       'REFUS_OBT':'Refus d\'obtempérer', 
       'DELIT_FUITE':'Délit de fuite',
       'ALCOOLEMIE':'Alcoolémie',
       'STUPEFIANT':'Prise de stupéfiants ou drogue',
       'AUTRE':'Autre'
    },'','Motif du retrait'],
    'date_assure_precedement':['date','','Date à partir de laquelle ce véhicule n\'a plus été assuré'],
    'ant_cylindree_399':['numeric',0,'Nombre de mois d\'expérience sur des véhicules de cylindrée inférieure à 399 cm3'],
    'ant_cylindree_599':['numeric',0,'Nombre de mois d\'expérience sur des véhicules de cylindrée entre 400 cm3 et 599 cm3'],
    'ant_cylindree_9999':['numeric',0,'Nombre de mois d\'expérience sur des véhicules de cylindrée supérieure à 600 cm3'],

    'marque':['uppercase',false,'Marque'],
    'modele':['uppercase',false,'Modèle'],
    'cylindree':['numeric',false,'Cylindrée'],
    'sra':['nonempty',false,'Code SRA'],
    'homologue':['ouinon','O','Véhicule homologué ?'],
    'date_mise_en_circulation':['date',false,'Mise en circulation'],
    'date_acquisition':['date',false,'Acquisition'],
    'assur_23_mois':[
        'ouinon',
        false,
        'Êtes-vous assuré pour ce véhicule depuis plus de 23 mois ?'
    ],

    'conducteur_2':['ouinon', 'N', 'Autre conducteur du véhicule à assurer ?' ],
    'civilite_2':[{'MR':'Monsieur','MME':'Madame'}, 'MR', 'Civilité du conducteur secondaire'],
    'nom_2':['nonempty', 'ANONYME', 'Nom du conducteur secondaire' ],
    'prenom_2':['nonempty', 'ANONYME', 'Prénom du conducteur secondaire' ],
    'date_naissance_2':['date', '', 'Date de naissance conducteur secondaire' ],
    'date_obtention_permis_2':['date', '', 'Date d\'obtention du permis B du conducteur secondaire' ],
    'parente_2':[{'CF':'Conjointe / concubine','CM':'Conjoint / concubin'}, '', 'Lien de parenté du conducteur secondaire' ],

    'nb_mois_moto':[
        'numeric',false,'Nombre de mois d\'assurance moto durant les 24 derniers mois'
    ],
    'nb_mois_auto':[
        'numeric','0','Nombre de mois d\'assurance auto durant les 24 derniers mois'
    ],
    'mode_garage':[
        {   '1':'Sur la voie publique',
            '2':'Parking fermé',
            '3':'Garage privatif fermé',
            'AUT':'Autre'
        },'1','Mode de garage'
    ],
    'mode_garage_rue':['ouinon','O','Stationnement dans la rue (voie publique)'],
    'mode_garage_prive':['ouinon','N','Lieu de stationnement individuel'],
    'mode_garage_clos':['ouinon','N','Lieu de stationnement clos'],
    'mode_garage_couvert':['ouinon','N','Lieu de stationnement couvert'],
    'code_postal':['numeric',false,'Code postal'],
    'ville':['nonempty',false,'Ville'],
    'usage':[{'P':'Tous (sauf coursier, livreur, taxi)','L':'Limité aux voies non ouvertes à la circulation'},false,'Usage du véhicule'],
    'carte_grise_france':['ouinon',false,'Carte grise française ?'],
    'carte_grise_titulaire':[
        {'O':'Vous, conjoint, parents',
        'G':'Société dont vous êtes gérant',
        'C':'Société dont vous êtes associé',
        'A':'Autre'}, false, 'Titulaire de la carte grise'],
    'mode_acquisition':[
        {'1':'Comptant',
            '2':'Crédit',
            '3':'Leasing'
        },'1','Mode d\'acquisition'
    ],
    'civilite':[{'MR':'Monsieur','MME':'Madame'},false,'Civilité'],
    'date_naissance':['date',false,'Date de naissance'],
    'situation_famille':[
        {'E':'Marié', 
        'G':'Célibataire',
        'I':'Concubin',
        'K':'Pacsé',
        'M':'Divorcé', 
        'P':'Veuf'}, false, 'Situation de famille'],
    'nombre_enfants':['numeric',false,'Nombre d\'enfants'],
    'csp':[
        {'01':'Agriculteurs(trice)',
        '05':'Artisan(e)',
        '10':'Commerçant(e)',
        '15':'Salarié(e)',
        '20':'Chef d\'entreprise',
        '25':'Etudiant(e)/Stagiaire',
        '30':'Fonctionnaire ou assimilé(e)',
        '35':'Libérale/Indépendant(e)',
        '40':'Retraité(e)',
        '45':'VRP',
        '70':'Demandeur d\'emploi',
        '80':'Sans profession',
        '90':'Taxi',
        '92':'Forain',
        '93':'Autre'
        },false,'Profession/CSP'
    ],
    'norme_permis':[
        {'F':'FR', 
        'E':'Union européenne',
        'A':'Autre'},false,'Norme de votre permis'],
    'categorie_permis':[
        {'A':'A',
        'A2':'A2', 
        'B':'B', 
        'AL':'A1/AL',
        'BSR':'BSR',
        'AM':'AM'
        },false,'Catégorie de votre permis'
    ],
    'previous_insurer':['nonempty','','Compagnie d\'assurance du précédent véhicule (moto)'],
    'previous_insurer_autre':['nonempty','','Vous avez choisi "Autre". Saissez ici librement le nom de la précédente compagnie d\'assurance'],
    'previous_insurer_axa_num':['nonempty','','Numéro de contrat AXA'], // missing in solly import
    'previous_insurer_term':['date','','Date de résiliation (précédent assureur)'],
    'previous_insurer_term_company':['ouinon','N','Résiliation à la demande de l\'assureur'],
    'previous_insurer_term_date':['date','','Date de dernière échéance anniversaire'],
    'previous_insurer_immat':['text','','Immatriculation du dernier véhicule assuré'],
    'date_permis_B':['date','','Date d\'obtention du permis B'],
    'cac':['ouinon',false,'Permis obtenu en conduite accompagnée'],
    'date_obtention_permis':['date',false,'Date d\'obtention du permis'],
    'aussi_permis_A2':['ouinon',false,'Vous avez aussi le permis A2'], // 'RDO_AUTRP'
    'date_obtention_permis_A2':['date','','Date d\'obtention du permis A2'], //'ZZZ_DPAUTR'
    'permis_A_obtenu_par_formation':['ouinon','O','Confirmez-vous avoir obtenu le permis A par formation ?'], //'RDO_AFORM'
    'bridee_47_5CV':['ouinon','O','Votre deux-roues est bridé à 47,5CV (35kW)'],
    'formation_F125':['ouinon','O','Pour conduire avec un permis B, vous avez reçu une formation pratique dispensée par un organisme agréé OU avez-vous été assuré(e) pour un tricycle ou moto de plus de 50 cm3 entre le 01/01/2006 et 31/12/2010'],
    'antecedant_400cm3_24mois':['ouinon','N','Au cours des 36 derniers mois vous avez assuré une moto de plus de 400 cm3 pendant au moins 24 mois'],
    'assure_actuellement':['ouinon',false,'Vous êtes actuellement assuré(e) pour une Auto et/ou une Moto'],
    'antecedant_assur':[
        {'36':'Depuis 36 mois ou plus',
        '24':'Depuis 24 mois et moins de 36 mois',
        '12':'Depuis 12 mois et moins de 24 mois',
        '01':'Moins de 12 mois'
        },'01','Assuré à votre nom et sans interruption depuis'
    ],
    'antecedant_non_assur':[
        {'23':'Entre 24 et moins de 36 mois consécutifs',
        '10':'Entre 12 et moins de 24 mois consécutifs',
        '02':'Jamais ou moins de 12 mois consécutifs'
        },'02','Au cours des 36 derniers mois, vous avez été assuré à votre nom en auto'
    ],
    'coefficient_auto':['numeric',false,'Bonus auto'],
    'coefficient_moto':['numeric',false,'Bonus moto'],
    'bonus_50_plus_3_ans':['ouinon','N','Le bonus 50 actuel est acquis depuis 3 ans ou plus'],
    'autre_conducteur':['ouinon','N'], // TODO : voir les params supplémentaire si oui
    'ant_delit_fuite':['ouinon','N','Au cours des 5 dernières années, vous avez été poursuivi ou condamné pour délit de fuite'],
    'ant_retrait':['ouinon',false,'D\'un retrait/suspension de permis de conduire'],
    'ant_retrait_date':['date','','Date du retrait'],
    'ant_retrait_duree_mois':['numeric','','Durée du retrait en mois'],
    'ant_retrait_motif':[{
       '':'N/A',
       'RETRA':'excès de vitesse', 
       'REFUS':'refus d\'obtempérer', 
       'FUITE':'délit de fuite', 
       'AUTRE':'autre'
    },'','Motif du retrait'],
    'ant_retrait_recidive':['ouinon','N','Le motif du retrait est-il une récidive'],
    'ant_annulation':['ouinon',false,'D\'une annulation de permis'],
    'ant_annulation_date':['date','','Date de l\'annulation'],
    'ant_alcool':['ouinon',false,'De sanctions en état d\'ébriété'],
    'ant_alcool_date':['date','','Date de l\'alcootest'],
    'ant_alcool_taux':[{
        '':'N/A',
        '099':'Moins de 0,5mg par litre d\'air expiré',
        '100':'Moins de 1g/1000 dans le sang', 
        '124':'Entre 0,5mg et 0,625mg par litre d\'air expiré', 
        '125':'Entre 1g et 1,25g/1000 dans le sang', 
        '149':'Entre 0,626mg et 0,75mg par litre d\'air  expiré', 
        '150':'Entre 1,26g et 1,5g/1000 dans le sang', 
        '199':'Entre 0,76mg et 1mg par litre d\'air expiré', 
        '200':'Entre 1,51g/1000 et 2g/1000 dans le sang', 
        '224':'Plus de 1mg par litre d\'air expiré', 
        '225':'Plus de 2g/1000 dans le sang'
    },'','Taux d\'alcool mesuré'],
    'ant_alcool_sinistre':[{
        '':'N/A', 'N':'Non', 'M':'Matériel', 'C':'Corporel'
    },'','Cette infraction a-t-elle entrainée un siniste'],
    'ant_alcool_recidive':['ouinon','','S\'agit-il d\'une récidive?'],
    'ant_stupefiants':['ouinon',false,'De poursuites ou condamnations pour conduite sous l\'emprise de stupéfiants, drogues ou médicaments non prescrits'],
    'ant_stupefiants_date':['date','','Date de l\'infraction'],
    'ant_stupefiants_substance':['nonempty','','Nature de la substance'],
    'ant_stupefiants_sinistre':[{
        '':'N/A', 'N':'Non', 'M':'Matériel', 'C':'Corporel'
    },'','Cette infraction a-t-elle entrainée un siniste'],
    'ant_stupefiants_recidive':['ouinon','','S\'agit-il d\'une récidive?'],
    'ant_resiliation':['ouinon',false,'D\'une résiliation par un précédent assureur'],
    'ant_resiliation_date':['date','','Date de la résiliation'],
    'ant_resiliation_non_paiement':['ouinon','N','Résilié pour non paiement'], // RDO_NP
    'ant_resiliation_fausse_declaration':['ouinon','N','Résilié pour fausse déclaration ou aggravation'], // RDO_FD
    'ant_resiliation_frequence_sinistres':['ouinon','N','Résilié pour fréquence de sinistres'], // RDO_FS
    'ant_resiliation_autre_motif':['ouinon','N','Résilié pour autres motifs'], // RDO_AM
    'sinistres_nr':['ouinon',false,'Sinistres non responsable, vol, incendie'],
    'sinistres_nr_date1':['date','','Date sinistre non responsable survenu durant les 3 dernières années'],
    'sinistres_nr_type1':[{'AUTO':'en auto','MOTO':'en moto'},'MOTO'],
    'sinistres_nr_date2':['date',''],
    'sinistres_nr_type2':[{'AUTO':'en auto','MOTO':'en moto'},'MOTO'],
    'sinistres_nr_date3':['date',''],
    'sinistres_nr_type3':[{'AUTO':'en auto','MOTO':'en moto'},'MOTO'],
    'sinistres_nr_date4':['date',''],
    'sinistres_nr_type4':[{'AUTO':'en auto','MOTO':'en moto'},'MOTO'],
    'sinistres_nr_date5':['date',''],
    'sinistres_nr_type5':[{'AUTO':'en auto','MOTO':'en moto'},'MOTO'],
    'sinistres_nr_date6':['date',''],
    'sinistres_nr_type6':[{'AUTO':'en auto','MOTO':'en moto'},'MOTO'],
    'sinistres_vi_date1':['date','','Date sinistre vol incendie survenu durant les 3 dernières années'],
    'sinistres_vi_type1':[{'AUTO':'en auto','MOTO':'en moto'},'MOTO'],
    'sinistres_vi_date2':['date',''],
    'sinistres_vi_type2':[{'AUTO':'en auto','MOTO':'en moto'},'MOTO'],
    'sinistres_vi_date3':['date',''],
    'sinistres_vi_type3':[{'AUTO':'en auto','MOTO':'en moto'},'MOTO'],
    'sinistres_vi_date4':['date',''],
    'sinistres_vi_type4':[{'AUTO':'en auto','MOTO':'en moto'},'MOTO'],
    'sinistres_vi_date5':['date',''],
    'sinistres_vi_type5':[{'AUTO':'en auto','MOTO':'en moto'},'MOTO'],
    'sinistres_vi_date6':['date',''],
    'sinistres_vi_type6':[{'AUTO':'en auto','MOTO':'en moto'},'MOTO'],
    'sinistres_bg_date1':['date',''],
    'sinistres_bg_date2':['date',''],
    'sinistres_bg_date3':['date',''],
    'sinistres_bg_date4':['date',''],
    'sinistres_bg_date5':['date',''],
    'sinistres_mr':['ouinon',false,'Sinistres matériel responsable'],
    'sinistres_mr_date1':['date','','Date sinistre matériel responsable survenu durant les 3 dernières années'],
    'sinistres_mr_type1':[{'AUTO':'en auto','MOTO':'en moto'},'MOTO'],
    'sinistres_mr_date2':['date',''],
    'sinistres_mr_type2':[{'AUTO':'en auto','MOTO':'en moto'},'MOTO'],
    'sinistres_mr_date3':['date',''],
    'sinistres_mr_type3':[{'AUTO':'en auto','MOTO':'en moto'},'MOTO'],
    'sinistres_mr_date4':['date',''],
    'sinistres_mr_type4':[{'AUTO':'en auto','MOTO':'en moto'},'MOTO'],
    'sinistres_mr_date5':['date',''],
    'sinistres_mr_type5':[{'AUTO':'en auto','MOTO':'en moto'},'MOTO'],
    'sinistres_cr':['ouinon',false,'Sinistres corporel responsable'],
    'sinistres_cr_date1':['date','','Date sinistre corporel responsable survenu durant les 3 dernières années'],
    'sinistres_cr_type1':[{'AUTO':'en auto','MOTO':'en moto'},'MOTO'],
    'sinistres_cr_date2':['date',''],
    'sinistres_cr_type2':[{'AUTO':'en auto','MOTO':'en moto'},'MOTO'],
    'assure_12_sur_36':['ouinon','','Avez-vous été assuré 12 mois parmis les 36 derniers mois ?'],

    'taux_commission':['float',false],
    'frais':['float','120.00','Montant des frais de courtage'],
    'frais_sup':['float','0.00','Appliquer des frais supplémentaires'],
    'nom':['nonempty',false, 'Nom' ],
    'prenom':['nonempty',false, 'Prénom' ],
    'chez':['text','', 'Chez'],
    'adresse':['nonempty','', 'N° et rue'],
    'adresse2':['text','','Bâtiment, étage, ...'],
    'adresse3':['text','','Adresse'],
    'telephone':['numeric',false,'Téléphone'],
    'email':['email',false,'Adresse email'],

    'accept_cgu':['ouinon','N',<>J'accepte les <a className="inline" href="https://xenabot.assurbonplan.fr/CGU.pdf" target="_blank">Conditions Générales d'Utilisation</a> et d'être contacté concernant les offres d'Assur Bon Plan et de leurs partenaires.</>],
    'automatic_emails':['ouinon','O','J\'accepte de recevoir des emails automatisés de la part d\'AssurBonPlan.'],

    'hamon_deja_assure':['ouinon',false,'Ce véhicule est-il déjà assuré ?'],
    'hamon_assure_au_moins_12_mois':['ouinon',false,'Ce véhicule est-il déjà assuré depuis au moins 12 mois ?'],
    'hamon_resiliation_necessaire':['ouinon',false,'Est-il nécessaire de résilier le contrat actuel ?'],
    'hamon_resiliation_envoyee':['ouinon',false,'La résiliation a-t-elle déjà été envoyée ?'],
    'date_effet':['date',false,'À quelle date souhaitez-vous faire débuter votre contrat ?'],
    'periodicite':[
        {'A':'Annuel','S':'Semestrielle','M':'Mensuelle'}, false,'Périodicité'
    ],
    'formule':['nonempty',false,'Choix de la formule'],
    'numero_permis':['nonempty',false,'N° de permis de conduire'],
    'immatriculation':['nonempty',false,'Immatriculation du véhicule'],
    'numero_serie':['text',false,'N° de série du véhicule'],
    'numero_serie_inconnu':['ouinon','N','Je ne connais pas mon numéro de série'],
    'assure_30_derniers_jours':['ouinon',false,'Ce véhicule a-t-il été assuré à votre nom durant les 30 derniers jours'],
    'iban':['text',false,'IBAN du compte bancaire sur lequel vos prochaines cotisations seront prélevées'],
    'bic':['text',false,'Code BIC de l\'établissement bancaire'],
    'own_iban':['ouinon','N','Je suis le détenteur du compte bancaire désigné ci-dessus'],
    'ne_en_france':['ouinon',false,'Êtes-vous né(e) en France ?'],
    'commune_naissance':['text','','Commune de naissance :'],
    'pays_naissance':[{"":"Selectionnez votre pays de naissance","AF":"AFGHANISTAN","FF":"AFRIQUE","ZA":"AFRIQUE DU SUD","AL":"ALBANIE","DZ":"ALGERIE","DE":"ALLEMAGNE","AD":"ANDORRE","AO":"ANGOLA","AI":"ANGUILLA","AQ":"ANTARCTIQUE","AG":"ANTIGUA ET BARBUDA","AN":"ANTILLES NEERLANDAISES","SA":"ARABIE SAOUDITE","AR":"ARGENTINE","AM":"ARMENIA","AW":"ARUBA","AU":"AUSTRALIE","AT":"AUTRICHE","AZ":"AZERBAIDJAN","BS":"BAHAMAS","BH":"BAHREIN","BD":"BANGLADESH","BB":"BARBADE","BE":"BELGIQUE","BZ":"BELIZE","BJ":"BENIN","BM":"BERMUDES","BT":"BHOUTAN","BY":"BIELORUSSIE","BO":"BOLIVIE","BA":"BOSNIE-HERZEGOVINE","BW":"BOTSWANA","BR":"BRESIL","BN":"BRUNEI DARUSSALAM","BG":"BULGARIE","BF":"BURKINA FASO","BI":"BURUNDI","KH":"CAMBODGE","CM":"CAMEROUN","CA":"CANADA","CV":"CAP-VERT","CL":"CHILI","CN":"CHINE","CY":"CHYPRE","CO":"COLOMBIE","KM":"COMORES","KP":"COREE DU NORD","KR":"COREE DU SUD","CR":"COSTA RICA","CI":"COTE D'IVOIRE","HR":"CROATIE","CU":"CUBA","DK":"DANEMARK","DJ":"DJIBOUTI","DM":"DOMINIQUE","EG":"EGYPTE","SV":"EL SALVADOR","AE":"EMIRATS ARABES UNIS","EC":"EQUATEUR","ER":"ERYTHREE","ES":"ESPAGNE","EE":"ESTONIE","US":"ETATS UNIS","ET":"ETHIOPIE","FO":"FEROE, ILES","FJ":"FIDJI","FI":"FINLANDE","GA":"GABON","GM":"GAMBIE","GE":"GEORGIE","GS":"GEORGIE DU SUD ET ILES SANDWIC","GH":"GHANA","GI":"GIBRALTAR","GR":"GRECE","GD":"GRENADE","GL":"GROENLAND","GP":"GUADELOUPE","GU":"GUAM","GT":"GUATEMALA","GN":"GUINEE","GQ":"GUINEE EQUATORIALE","GW":"GUINEE-BISSAO","GF":"GUYANE FRANCAISE","HT":"HAITI","HN":"HONDURAS","HK":"HONG KONG","HU":"HONGRIE","BV":"ILE BOUVET","CX":"ILE CHRISTMAS","MU":"ILE MAURICE","NF":"ILE NORFOLK","KY":"ILES CAIMANS","CC":"ILES COCOS","CK":"ILES COOK","HM":"ILES HEARD MCDONALD","MP":"ILES MARIANNES","MH":"ILES MARSHALL","UM":"ILES MINEURES ELOIGNEES DES EU","NU":"ILES NIUE","PN":"ILES PITCAIRN","SB":"ILES SALOMON","SJ":"ILES SVALBARD","TC":"ILES TURKS ET CAIQUES","VG":"ILES VIERGES BRITANNIQUES","VI":"ILES VIERGES DES ETATS-UNIS","IN":"INDE","ID":"INDONESIE","IQ":"IRAK","IR":"IRAN","IE":"IRLANDE","IS":"ISLANDE","IL":"ISRAEL","IT":"ITALIE","JM":"JAMAIQUE","JP":"JAPON","JO":"JORDANIE","KZ":"KAZAKHSTAN","KE":"KENYA","KG":"KIRGHIZISTAN","KI":"KIRIBATI","KW":"KOWEIT","LA":"LAOS","SC":"LES SEYCHELLES","LS":"LESOTHO","LV":"LETTONIE","LB":"LIBAN","LR":"LIBERIA","LY":"LIBYE","LI":"LIECHTENSTEIN","LT":"LITUANIE","LU":"LUXEMBOURG","MO":"MACAO","MK":"MACEDOINE","MG":"MADAGASCAR","MY":"MALAISIE","MW":"MALAWI","MV":"MALDIVES","ML":"MALI","FK":"MALOUINES","MT":"MALTE","MA":"MAROC","MQ":"MARTINIQUE","MR":"MAURITANIE","YT":"MAYOTTE","MX":"MEXIQUE","FM":"MICRONESIE","MD":"MOLDAVIE","MC":"MONACO","MN":"MONGOLIE","ME":"MONTENEGRO","MS":"MONTSERRAT","MZ":"MOZAMBIQUE","MM":"MYANMAR","NA":"NAMIBIE","NR":"NAURU","NP":"NEPAL","NI":"NICARAGUA","NE":"NIGER","NG":"NIGERIA","NO":"NORVEGE","NZ":"NOUVELLE ZELANDE","NC":"NOUVELLE-CALEDONIE","OM":"OMAN","UG":"OUGANDA","UZ":"OUZBEKISTAN","PK":"PAKISTAN","PW":"PALAOS","PA":"PANAMA","PG":"PAPOUASIE-NOUVELLE-GUINEE","PY":"PARAGUAY","NL":"PAYS-BAS","PE":"PEROU","PH":"PHILIPPINE","PL":"POLOGNE","PF":"POLYNESIE FRANCAISE","PR":"PORTO RICO","PT":"PORTUGAL","QA":"QATAR","CF":"REPUBLIQUE CENTRAFRICAINE","CG":"REPUBLIQUE DEMOCRATIQUE CONGO","DO":"REPUBLIQUE DOMINICAINE","CD":"REPUBLIQUE DU CONGO","CZ":"REPUBLIQUE TCHEQUE","RE":"REUNION","RO":"ROUMANIE","GB":"ROYAUME-UNI","RU":"RUSSIE","RW":"RWANDA","EH":"SAHARA OCCIDENTAL","PM":"SAINT PIERRE ET MIQUELON","SM":"SAINT-MARIN","MF":"SAINT-MARTIN","SH":"SAINTE-HELENE","LC":"SAINTE-LUCIE","WS":"SAMOA","AS":"SAMOA AMERICAIN","ST":"SAO TOME-ET-PRINCIPE","SN":"SENEGAL","RS":"SERBIE","SL":"SIERRA LEONE","SG":"SINGAPOUR","SK":"SLOVAQUIE","SI":"SLOVENIE","SO":"SOMALIE","SD":"SOUDAN","LK":"SRI LANKA","KN":"ST. KITTS ET NEVIS","VC":"ST-VINCENT-ET-LES-GRENADINES","SE":"SUEDE","CH":"SUISSE","SR":"SURINAM","SZ":"SWZILAND","SY":"SYRIE","TJ":"TADJIKISTAN","TW":"TAIWAN","TZ":"TANZANIE","TD":"TCHAD","IO":"TERRITOIRE BRITANNIQUE DANS OC","TF":"TERRITOIRES D OUTRE MER","TH":"THAILANDE","TL":"TIMOR-LESTE","TG":"TOGO","TK":"TOKELAU","TO":"TONGA","TT":"TRINITE-ET-TOBAGO","TN":"TUNISIE","TM":"TURKMENISTAN","TR":"TURQUIE","TV":"TUVALU","UA":"UKRAINE","UY":"URUGUAY","VU":"VANUATU","VA":"VATICAN","VE":"VENEZUELA","VN":"VIETNAM","WF":"WALLIS ET FUTUNA","YE":"YEMEN","YU":"YOUGOSLAVIE","ZM":"ZAMBIE"},
        false,'Pays de naissance']
};

DataDevis.typeToN = { 'nr':6, 'vi':6, 'bg':6, 'mr':5, 'cr':2 }

DataDevis.dateToParam = date => date ? ''+date.getDate().toString().padStart(2,'0')+'/'+(date.getMonth()+1).toString().padStart(2,'0')+'/'+date.getFullYear().toString().padStart(4,'0') : ''

DataDevis.paramToDate = param => {
    if ( !param ) return false
    const m = param.match(/([0-9]{1,2})\/([0-9]{1,2})\/([0-9]{4})/)
    return m ? new Date(m[3],m[2]-1,m[1]) : false
}

// 1. Convert Date -> "MM/YYYY"
DataDevis.monthToParam = date => {
    if (!date || !(date instanceof Date)) return '';
    return `${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;
};

// 2. Convert "MM/YYYY" -> Date
DataDevis.paramToMonth = param => {
    if (!param) return null; // Matches your useState(false) pattern
    
    // Regex: Start(^), Month, Slash, Year, End($)
    const m = param.match(/^(\d{1,2})\/(\d{4})$/); 

    if (!m) return null;

    // new Date(Year, MonthIndex, Day)
    // Note: m[2] is year, m[1] is month
    return new Date(parseInt(m[2]), parseInt(m[1]) - 1, 1);
};

DataDevis.sinistreTypeToDisplay = {'nr':'Non responsable','vi':'Vol ou incendie','bg':'Bris de glace','mr':'Matériel responsable','cr':'Corporel responsable'}

DataDevis.zFormToDisplay = {
    'M2':'Formule au Tiers',
    'M3':'Formule Tiers + Vol & Incendie',
    'M4':'Formule Vol + Dommage Collision',
    'M7':'Formule Tous risques'
}

DataDevis.zFormToDisplayAuto = {
    'L1':'Responsabilité Civile + DPRSA + PJ',
    'L2':'L1 + Vol et Incendie + Bris de glace',
    'L3':'L2 + Dommages Tous Accidents'
}

DataDevis.zFormToTitle = {
    'M2':'Formule 1 ► Responsabilité Civile, Casque, Gants, Gilet AIRBAG, DPRSA, PJ',
    'M3':'Formule 2 ► F1 + Vol et Incendie',
    'M4':'Formule 3 ► F2 + Dommages Collision (accident avec un tiers identifié)',
    'M7':'Formule 4 ► F2 + Dommages Tous Accidents'
}

DataDevis.zFormToTitleAuto = {
    'L1':'Formule 1 ► Responsabilité Civile + DPRSA + PJ',
    'L2':'Formule 2 ► F1 + Vol et Incendie + Bris de glace',
    'L3':'Formule 3 ► F2 + Dommages Tous Accidents'
}


DataDevis.zFormToExplain = {
    'M2':'Responsabilité Civile et Défense Pénale et Recours Suite à Accident. Protection juridique / Garantie casque, gants et gilet, airbag du conducteur et son passager',
    'M3':'Catastrophes Naturelles, Catastrophes Technologiques, attentats, Garantie valeur à neuf, garantie caques et gants, protection juridique',
    'M4':'Accident avec un tiers identifié',
    'M7':'Dommages tous accidents'
}


DataDevis.zFormToDetailsAlone = {
    'M2':<><p>
    La Compagnie vous garantit contre les conséquences pécuniaires de la Responsabilité Civile que vous pouvez encourir en raison des dommages matériels et corporels que vous pouvez causer à autrui, y compris à votre passager.
    </p><p>
    Défense pénale et recours suite à accident
    La Compagnie s'engage à réclamer la réparation des préjudices corporels ou matériels subis par l'assuré et les personnes transportées suite à un accident.
    </p><p>
    Dommages corporels illimités - Dommages matériels limités à 100000000 EUR en cas d'accident et 1300000 EUR en cas d'incendie. Une franchise supplémentaire de 1000 EUR sera appliquée si au moment du sinistre, vous ou un conducteur désigné n'êtes pas le pilote du véhicule.
    </p></>,
    'M3':<><p>
    Votre véhicule doit :<br/>
    1- être équipé d'un système électronique ou mécanique de protection antivol classe SRA,<br/>
    2- être gravé et inscrit à votre nom au fichier central des véhicules gravés (ARGOS) par une société de gravage des deux roues agréée SRA.Remboursement des dommages directs résultant de la disparition ou de la détérioration de votre véhicule causés exclusivement par un vol, un incendie ou une tentative de vol matérialisée par des traces d'effraction, à concurrence de sa valeur de remplacement, à dire d'expert, au jour du sinistre ou du prix d'acquisition pour les véhicules acquis neufs depuis moins de 6 mois (Sauf : location longue durée, location avec option d'achat et crédit-bail), déduction faite d'une franchise de 10 % (avec minimum 400 EUR et maximum 800 EUR). Si vous ne pouvez justifier de la mise en œuvre de ces deux protections (antivol mécanique ou électronique ET gravage), la franchise sera doublée.
    </p><p>
    Protection juridique y compris prise en charge de 50% du stage de récupération de points du permis.
    Garantie casque, gants du conducteur et son passager (250€ pour le casque, 70€ pour les gants)
    </p></>,
    'M4':<p>
    Remboursement des dommages subis par votre véhicule ayant pour cause exclusive une collision (choc) avec un tiers identifié à concurrence de sa valeur de remplacement, à dire d'expert, au jour du sinistre ou du prix d'acquisition pour les véhicules acquis neufs depuis moins de 6 mois (Sauf : LDD, LOA et crédit-bail), déduction faite d'une franchise de 10 % (avec minimum 400 EUR et maximum 800 EUR). Une franchise supplémentaire de 1000 EUR sera appliquée si, au moment du sinistre, vous ou un conducteur désigné n'êtes pas le pilote du véhicule.
    </p>,
    'M7':<><p>
    DOMMAGES TOUS ACCIDENTS ('TOUS RISQUES')
    Remboursement des dommages subis par votre véhicule suite à un accident (avec ou sans collision et que le véhicule ait été en mouvement ou à l'arrêt) à concurrence de sa valeur de remplacement, à dire d'expert, au jour du sinistre ou du prix d'acquisition pour les véhicules acquis neufs depuis moins de 6 mois (Sauf : LLD, LOA et crédit-bail), déduction faite d'une franchise de 10 % (avec minimum 400 EUR et maximum 800 EUR). Une franchise supplémentaire de 1000 EUR sera appliquée si au moment du sinistre vous ou un conducteur désigné n'êtes pas le pilote du véhicule.
    </p></>,
    'L1':<p>RESPONSABILITE CIVILE<br/>
    La Compagnie vous garantit contre les conséquences pécuniaires de la Responsabilité Civile que vous pouvez encourir en raison des dommages
    matériels et corporels que vous pouvez causer à autrui, y compris à votre passager. Dommages corporels illimités - Dommages matériels limités à
    100000000 EUR en cas d'accident et 1300000 EUR en cas d'incendie.
    Une franchise supplémentaire de 750 EUR sera appliquée si au moment du sinistre, vous ou un conducteur désigné n'êtes pas le pilote du véhicule.<br/>
    DEFENSE PENALE ET RECOURS SUITE à ACCIDENT<br/>
    La Compagnie s'engage à réclamer, soit à l'amiable, soit devant toute juridiction la réparation des préjudices corporels ou matériels
    subis par l'Assuré et les personnes transportées suite à un accident imputable à un tiers, ainsi qu'a soutenir la défense de l'assuré devant
    les tribunaux répressifs à la suite d'un accident pour lequel il serait cité en qualité de propriétaire ou gardien du véhicule assuré à
    concurrence de 2300 EUR.<br/>
    PROTECTION JURIDIQUE<br/>
    Protection juridique en cas de conflit lors de l'achat, la vente, l'entretien ou le financement du véhicule assuré, contre les conséquences d'une
    infraction aux règles de la circulation et pour la prise en charge à concurrence de 50% du prix du stage de reconstitution de point.</p>,
    'L2':<p>VOL / INCENDIE<br/>
    Remboursement à concurrence de la valeur de remplacement du véhicule au jour du sinistre ou du prix d'acquisition pour les véhicules mis en
    circulation depuis moins de 12 mois (Sauf : location longue durée, location avec option d'achat et crédit-bail), des dommages directs résultant
    de la disparition ou de la détérioration de votre véhicule causés exclusivement par un vol, un incendie, déduction faite d'une franchise de 250 EUR,
    et des dommages directs résultant d'une tentative de vol matérialisée par des traces d'effraction.<br/>
    BRIS DE GLACE<br/>
    Bris de glace : pare brise, glaces latérales, lunette arrière, optiques de phares, franchise 75 EUR.</p>,
    'L3':<p>DOMMAGES TOUS ACCIDENTS ('TOUS RISQUES')<br/>
    Remboursement à concurrence de la valeur de remplacement du véhicule, à dire d'expert, au jour du sinistre ou du prix d'acquisition pour les
    véhicules mis en circulation depuis moins de 12 mois (Sauf : location longue durée, location avec option d'achat et crédit-bail), des
    dommages subis par votre véhicule à la suite d'un accident (avec ou sans collision et que le véhicule ait été en mouvement ou à l'arrêt)
    déduction faite d'une franchise de 250 EUR.<br/>
    Une franchise supplémentaire de 750 EUR sera appliquée si au moment du sinistre, vous ou un conducteur désigné n'êtes pas le conducteur du véhicule.</p>
}

DataDevis.zFormToDetails = {
    'M2':({extraDescription})=><><p>
    La Compagnie vous garantit contre les conséquences pécuniaires de la Responsabilité Civile que vous pouvez encourir en raison des dommages matériels et corporels que vous pouvez causer à autrui, y compris à votre passager.
    </p><p>
    Défense pénale et recours suite à accident
    La Compagnie s'engage à réclamer la réparation des préjudices corporels ou matériels subis par l'assuré et les personnes transportées suite à un accident.
    </p>
    <b>Offre Eco by Assur Bon Plan</b>
    <p>Dommages corporels illimités - Dommages matériels limités à 100000000 EUR en cas d'accident et 1300000 EUR en cas d'incendie. Une franchise supplémentaire de 1000 EUR sera appliquée si au moment du sinistre, vous ou un conducteur désigné n'êtes pas le pilote du véhicule.</p>
    <b>Offre Motard Protect</b>
    <p>Indemnisation des dommages que vous pourriez causer à d'autres lors d'un accident de la circulation.

    Plafond : 
    100 000 000 € pour les dommages matériels, sans limite pour les dommages corporels.

    Pas de franchise, sauf si vous prêtez votre véhicule à d'autres conducteurs et sous certaines conditions (Franchise de 1500€).</p>
    <p>Défense de vos droits en cas de poursuite pénale et exercice d'un recours amiable ou judiciaire pour vous ou les personnes transportées, suite à un accident de la circulation.
    Plafond :
    10 000 € de frais (protection juridique et DPRSA)
    Seuil d'intervention :
    250 € 
    </p>
    <p>Assistance au véhicule : Dépannage et remorquage de votre véhicule 24h/24, 7j/7
    Assistance aux personnes.

    Zone de couverture: 
    Pays listés dans les Conditions Générales

    Seuil d'intervention:
    30 km de chez vous (ou 0 Km avec l'option) en cas de panne, et sans seuil d'intervention dans les autres cas.
    Assistance aux personnes : 30 km de votre domicile. 
    </p>
    {extraDescription}
    </>,
    'M3':({extraDescription})=><><p>
    <b>Offre Eco by Assur Bon Plan :</b>
    </p><p>
    Votre véhicule doit :<br/>
    1- être équipé d'un système électronique ou mécanique de protection antivol classe SRA,<br/>
    2- être gravé et inscrit à votre nom au fichier central des véhicules gravés (ARGOS) par une société de gravage des deux roues agréée SRA.Remboursement des dommages directs résultant de la disparition ou de la détérioration de votre véhicule causés exclusivement par un vol, un incendie ou une tentative de vol matérialisée par des traces d'effraction, à concurrence de sa valeur de remplacement, à dire d'expert, au jour du sinistre ou du prix d'acquisition pour les véhicules acquis neufs depuis moins de 6 mois (Sauf : location longue durée, location avec option d'achat et crédit-bail), déduction faite d'une franchise de 10 % (avec minimum 400 EUR et maximum 800 EUR). Si vous ne pouvez justifier de la mise en œuvre de ces deux protections (antivol mécanique ou électronique ET gravage), la franchise sera doublée.
    </p><p>
    Protection juridique y compris prise en charge de 50% du stage de récupération de points du permis.
    Garantie casque, gants du conducteur et son passager (250€ pour le casque, 70€ pour les gants)
    </p><p>
    <b>Offre Assur Bon Plan</b>
    </p><p>
    Franchise relative 230 €
    Garantie casques jusqu’à 250 € et des gants jusqu’à 70 € : Casque et gants de moins de 5 ans, endommagés suite à un accident de la circulation.
    Vol, incendie et dommages des accessoires hors-série du véhicule assuré : 10% du montant du sinistre, 50 € minimum
    </p>
    <b>Offre Offre Motard Protect</b>
    <p>
        Prise en charge des dommages du pare-brise, bulle de carénage et optiques de phares avant et des glaces arrière et latérales. Les feux arrière sont couverts au titre de la garantie Dommages tous accidents, si celle-ci est souscrite.

        Plafond :
        Frais de réparation ou de remplacement

        Franchise :
        50€ + 10% sinistre
    </p>
    <p>
        Prise en charge des dommages résultant d'une catastrophe naturelle ou technologique, dès lors qu'elle est reconnue comme telle officiellement.

        Plafond :
        Valeur déterminée par un expert ou valeur majorée avec l'option Indemnisation renforcée.

        Franchise :
        Pas de franchise en cas de catastrophe technologique, franchise réglementaire en cas de catastrophe naturelle. 

    </p>
    <p>
        Prise en charge des dommages résultant de tempête, ouragan, cyclone, grêle, chute de neige, attentat ou acte de terrorisme.

        Plafond :
        Valeur déterminée par un expert ou valeur majorée avec l'option Indemnisation renforcée.

        Franchise :
        300€
    </p>
    <p>
        Prise en charge des dommages en cas de vol, tentative de vol, incendie, foudre ou explosion.

        Plafond :
        Valeur déterminée par un expert ou valeur majorée avec l'option Indemnisation renforcée.

        Franchise :
        300€

    </p>
    {extraDescription}
    </>,
    'M4':({extraDescription})=><p>
    Remboursement des dommages subis par votre véhicule ayant pour cause exclusive une collision (choc) avec un tiers identifié à concurrence de sa valeur de remplacement, à dire d'expert, au jour du sinistre ou du prix d'acquisition pour les véhicules acquis neufs depuis moins de 6 mois (Sauf : LDD, LOA et crédit-bail), déduction faite d'une franchise de 10 % (avec minimum 400 EUR et maximum 800 EUR). Une franchise supplémentaire de 1000 EUR sera appliquée si, au moment du sinistre, vous ou un conducteur désigné n'êtes pas le pilote du véhicule.
    {extraDescription}
    </p>,
    'M7':({extraDescription})=><><p>
    <b>Offre Eco by Assur Bon Plan :</b>
    </p><p>
    DOMMAGES TOUS ACCIDENTS ('TOUS RISQUES')
    Remboursement des dommages subis par votre véhicule suite à un accident (avec ou sans collision et que le véhicule ait été en mouvement ou à l'arrêt) à concurrence de sa valeur de remplacement, à dire d'expert, au jour du sinistre ou du prix d'acquisition pour les véhicules acquis neufs depuis moins de 6 mois (Sauf : LLD, LOA et crédit-bail), déduction faite d'une franchise de 10 % (avec minimum 400 EUR et maximum 800 EUR). Une franchise supplémentaire de 1000 EUR sera appliquée si au moment du sinistre vous ou un conducteur désigné n'êtes pas le pilote du véhicule.
    </p><p>
    <b>Offre Assur Bon Plan :</b>
    </p><p>
    Franchises variables égale à 15% des dommages ou du Vol avec un Minimum et un
    Maximum
    Hors option réduction de franchise et avec l’installation de l’antivol et du gravage :<br/>
    o Jusqu’à 400cm3 : Franchise Min 200 € et franchise Maxi de 400 €<br/>
    o Au-delà de 400cm3 : Franchise Min 400 € et franchise Max de 800 €<br/>
    Franchise réduite de moitié en cas de tentative de vol du véhicule assuré.
    Véhicules dotés du seul antivol :<br/>
    o Jusqu’à 400cm3 : mini 220 € / maxi 440 €<br/>
    o Au-delà de 400cm3 : mini : 440 € / maxi 880 €
    </p>
    <b>Offre Offre Motard Protect</b>
    <p>Garantie des dommages en cas d'accident (responsable ou non) ou de vandalisme.

        Plafond :
        Valeur déterminée par un expert ou valeur majorée avec l'option Indemnisation renforcée(selon véhicule).

        Franchise :
        300 € si vous êtes le conducteur. 1500 € si vous prêtez votre véhicule à d'autres conducteurs. 
    </p>
    {extraDescription}
    </>
}

DataDevis.zFormToUniqueDetails = {
    'M2':<>
    <p>
    La Compagnie vous garantit contre les conséquences pécuniaires de la Responsabilité Civile que vous pouvez encourir en raison des dommages matériels et corporels que vous pouvez causer à autrui, y compris à votre passager.
    </p><p>
    Défense pénale et recours suite à accident
    La Compagnie s'engage à réclamer la réparation des préjudices corporels ou matériels subis par l'assuré et les personnes transportées suite à un accident.
    </p>
    <p>Dommages corporels illimités - Dommages matériels limités à 100000000 EUR en cas d'accident et 1300000 EUR en cas d'incendie. Une franchise supplémentaire de 1000 EUR sera appliquée si au moment du sinistre, vous ou un conducteur désigné n'êtes pas le pilote du véhicule.</p>
    <p>Protection juridique (y compris prise en charge de 50% du stage de récupération de points du permis)/ Garantie casque, gants et gilet airbag du conducteur et son passager (250€ pour le casque, 70€ pour les gants et 500€ pour le gilet Airbag)</p>
    </>,
    'M3':<><p>
    Votre véhicule doit :<br/>
    1- être équipé d'un système électronique ou mécanique de protection antivol classe SRA,<br/>
    2- être gravé et inscrit à votre nom au fichier central des véhicules gravés (ARGOS) par une société de gravage des deux roues agréée SRA.</p>
    <p>Remboursement des dommages directs résultant de la disparition ou de la détérioration de votre véhicule causés exclusivement par un vol, un incendie ou une tentative de vol matérialisée par des traces d'effraction, à concurrence de sa valeur de remplacement, à dire d'expert, au jour du sinistre ou du prix d'acquisition pour les véhicules acquis neufs depuis moins de 6 mois (Sauf : location longue durée, location avec option d'achat et crédit-bail), déduction faite d'une franchise de 10 % (avec minimum 400 EUR et maximum 800 EUR). Si vous ne pouvez justifier de la mise en œuvre de ces deux protections (antivol mécanique ou électronique ET gravage), la franchise sera doublée.<br/>
    </p><p>
    Protection juridique y compris prise en charge de 50% du stage de récupération de points du permis.
    Garantie casque, gants du conducteur et son passager (250€ pour le casque, 70€ pour les gants)
    </p>
    <p>Garantie gilet airbag du conducteur et son passager(500€ pour le gilet Airbag)/ garantie valeur à neuf pendant 6 mois suivant l’achat pour les véhicules acquis neufs</p></>,
    'M4':<><p>
    Remboursement des dommages subis par votre véhicule ayant pour cause exclusive une collision (choc) avec un tiers identifié à concurrence de sa valeur de remplacement, à dire d'expert, au jour du sinistre ou du prix d'acquisition pour les véhicules acquis neufs depuis moins de 6 mois (Sauf : LDD, LOA et crédit-bail), déduction faite d'une franchise de 10 % (avec minimum 400 EUR et maximum 800 EUR). Une franchise supplémentaire de 1000 EUR sera appliquée si, au moment du sinistre, vous ou un conducteur désigné n'êtes pas le pilote du véhicule.
    </p></>,
    'M7':<>
    <p>
    DOMMAGES TOUS ACCIDENTS ('TOUS RISQUES')
    Remboursement des dommages subis par votre véhicule suite à un accident (avec ou sans collision et que le véhicule ait été en mouvement ou à l'arrêt) à concurrence de sa valeur de remplacement, à dire d'expert, au jour du sinistre ou du prix d'acquisition pour les véhicules acquis neufs depuis moins de 6 mois (Sauf : LLD, LOA et crédit-bail), déduction faite d'une franchise de 10 % (avec minimum 400 EUR et maximum 800 EUR). Une franchise supplémentaire de 1000 EUR sera appliquée si au moment du sinistre vous ou un conducteur désigné n'êtes pas le pilote du véhicule.
    </p>
    </>
}


DataDevis.zFormToSmallDisplay = {
    'M2':'Formule 1',
    'M3':'Formule 2',
    'M4':'Formule 3',
    'M7':'Formule 4'
}

DataDevis.zFormToSmallDisplayAuto = {
    'L1':'Formule 1',
    'L2':'Formule 2',
    'L3':'Formule 3'
}

DataDevis.regPrice = /^([\s0-9]+)(,[0-9]+)$/
DataDevis.priceFormatter = new Intl.NumberFormat('fr-FR',{
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

DataDevis.fancyPrice = ( price, post='', deflt=' -' ) => {
    if ( !price ) return deflt
    const pm = DataDevis.priceFormatter.format( price ).match(DataDevis.regPrice)
    return pm ? <>{pm[1]}<sup>{pm[2]}</sup>{post}</> : <>{price}{post}</>
}
